import {React,useState,useEffect} from 'react'
import TrendingProducts from './TrendingProducts'
import BestSales from './BestSales'
import products from '../assets/data/products'
import TimerCount from './TimerCount'
import NewArrivals from './NewArrivals'
import PopularCategory from './PopularCategory'
import useGetData from '../custom-hooks/useGetData'


const AllProducts = () => {

    const {data:productsData,loading} = useGetData('products')

    const [trending,setTrending] = useState([])
    const [bestSales,setBestSales] = useState([])

    const [mobileProducts,setMobileProducts] = useState([])
    const [popularProducts,setPopularProducts] = useState([])
    useEffect(()=>{
        const filterTrendingProducts = products.filter((item)=>item.category === 'chair')
        const filterBestProducts = products.filter((item)=>item.category === 'sofa')

        const filterMobileProducts = products.filter((item)=>item.category === 'mobile')
        const filterPopularProducts = products.filter((item)=>item.category === 'watch')

        setTrending(filterTrendingProducts)
        setBestSales(filterBestProducts)

        setMobileProducts(filterMobileProducts)
        setPopularProducts(filterPopularProducts)
    },[productsData]);

    


    return (
        <>
            <TrendingProducts productsData={productsData} loading={loading} data={trending}/>
            <BestSales productsData={productsData} loading={loading} data={bestSales}/>
            <TimerCount />
            <NewArrivals productsData={productsData} loading={loading} data={mobileProducts} />
            <PopularCategory productsData={productsData} loading={loading} data={popularProducts}/>
        </>
    )
}

export default AllProducts